import './index.styl'
import React from 'react'
import { Table, Button, Row, Col } from 'react-bootstrap'
import ReportRow from './report-row'


class Component extends React.Component {
  constructor (props) {
    super(props)
  }

  setReport (report) {
    const { actions } = this.props
    actions.setReport(report)
    actions.push('/headers')
  }

  render () {
    const { reports, fetched, fetching, actions, report } = this.props
    const rows = []

    if (fetched === false && fetching === false) {
      // Fetch the list of reports...
      actions.fetchReports()

      return (
        <main>
          <section className="container align-center">
            <h1 className="margin-top">Momentje...</h1>
          </section>
        </main>
      )
    }

    if (fetched === true && fetching === false && reports.length === 0) {
      return (
        <main>
          <section className="container align-center">
            <h1 className="margin-top">Geen opgeslagen rapportages gevonden</h1>
          </section>
        </main>
      )
    }

    if (fetched === true && fetching === false && reports.length > 0) {
      reports.forEach((r, index) => {
        rows.push(<ReportRow report={r} key={index} active={r.id === report} click={(e) => { this.setReport(r) }} />)
      })
    }

    return (
      <main>
        <section className="container">
          <Row>
            <Col xs={12}>
              {rows}
            </Col>
          </Row>
        </section>
      </main>
    )
  }
}

export default Component



// WEBPACK FOOTER //
// ./components/Reports/index.js